import { Quote, Star, MapPin, Camera, Phone, ArrowRight } from "lucide-react";

/**
 * ⚠️ 10Web AI WARNING — DO NOT REPLACE <Icon /> JSX with <img> tags.
 * All lucide icons here are wrapped with data-icon-container="lucide-do-not-replace".
 * Keep them as React components.
 */

/* ==========================================================================
   TESTIMONIAL PHOTOS — UPDATE URLS AFTER UPLOAD TO 10WEB
   ==========================================================================
   Best content: photo of finished install (driveway shot) — not portrait
   Recommended: 800×600 WebP @82 (~80KB)
   ========================================================================== */

const REVIEWS = [{
  rating: 5,
  photo: "https://goldgaragedoor.com.au/wp-content/uploads/2026/06/006f6538-1cb6-4cb5-960e-762edc18976a.jpg?v=cf27vj312gc",
  photoAlt: "Completed sectional garage door install in Bondi — Gold Garage Door",
  quote: "Saw their gallery on Instagram, picked the Monument ColorBond door they did in Bronte, asked them to do mine the same. Three weeks later it's done — looks identical to the photo. Easiest call I made all year.",
  name: "Daniel R.",
  suburb: "Bondi",
  install: "B&amp;D Panelift Icon · Monument",
  pill: "Picked from photos"
}, {
  rating: 5,
  photo: "https://goldgaragedoor.com.au/wp-content/uploads/2026/06/af6fac2d-e29d-43da-95f8-d40e8b7f8e7e.jpg?v=b80uoka6iz",
  photoAlt: "Insulated double garage door install in Castle Hill, Sydney",
  quote: "Asked Adam to send me photos of insulated double-door installs in the Hills district before booking. Got six, real ones, with the houses still standing. Picked the Castle Hill one — that's now my driveway. Couldn't fault a thing.",
  name: "Priya &amp; Marcus W.",
  suburb: "Castle Hill",
  install: "Steel-Line Therma-Lux · Double-bay",
  pill: "Double-bay install",
  featured: true
}, {
  rating: 5,
  photo: "https://goldgaragedoor.com.au/wp-content/uploads/2026/06/PHOTO-2026-04-13-20-04-40.webp?v=p1x0mzcxz39",
  photoAlt: "Heritage panel restore in Mosman, Sydney",
  quote: "Heritage home, original 1960s door, didn't want a modern replacement. Showed me their Mosman restore work, matched it exactly — paint, timber profile, period-correct hardware. Looks like the door's been there 60 years. Magic.",
  name: "Eleanor F.",
  suburb: "Mosman",
  install: "Heritage panel restore · Custom paint",
  pill: "Heritage restore"
}];
const NAVY = "#081438";
const NAVY_LIGHT = "#243752";
const GOLD = "#F5A623";
const GOLD_DARK = "#9A6400";
const FONT_HEAD = "'Plus Jakarta Sans', system-ui, sans-serif";
const FONT_BODY = "'Manrope', system-ui, sans-serif";
export default function GalleryTestimonials() {
  return <section className="relative overflow-hidden" style={{
    backgroundColor: NAVY,
    fontFamily: FONT_BODY,
    paddingTop: "110px",
    paddingBottom: "110px"
  }}>
      {/* Ambient radial */}
      <div aria-hidden className="absolute inset-0" style={{
      background: `radial-gradient(circle at 50% 0%, ${NAVY_LIGHT}55 0%, ${NAVY} 50%), radial-gradient(circle at 50% 100%, ${GOLD}10 0%, transparent 40%)`
    }} />

      {/* Grain */}
      <div aria-hidden className="absolute inset-0 opacity-[0.05] pointer-events-none" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence baseFrequency='0.9'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.6'/%3E%3C/svg%3E\")"
    }} />

      {/* Top gold scanline */}
      <div aria-hidden className="absolute top-0 left-0 right-0 h-px" style={{
      background: `linear-gradient(90deg, transparent, ${GOLD}66 50%, transparent)`
    }} />

      {/* Watermark */}
      <div aria-hidden className="absolute pointer-events-none select-none" style={{
      left: "-30px",
      top: "40px",
      fontFamily: FONT_HEAD,
      fontSize: "240px",
      fontWeight: 800,
      lineHeight: 1,
      letterSpacing: "-0.05em",
      color: `${GOLD}12`
    }}>
        07
      </div>

      <div className="relative max-w-[1280px] mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="mb-14 max-w-3xl">
          <div className="mb-5 flex items-center gap-3">
            <div aria-hidden className="h-px w-12" style={{
            backgroundColor: GOLD
          }} />
            <span style={{
            fontFamily: FONT_HEAD,
            fontSize: "12px",
            fontWeight: 700,
            letterSpacing: "0.22em",
            textTransform: "uppercase",
            color: GOLD
          }}>
              07 · From Photo to Driveway
            </span>
          </div>

          <h2 style={{
          fontFamily: FONT_HEAD,
          fontWeight: 800,
          fontSize: "clamp(2.1rem, 4vw, 3.4rem)",
          lineHeight: 1.08,
          letterSpacing: "-0.025em",
          color: "#ffffff",
          marginBottom: "20px"
        }}>
            Customers who saw a photo,
            <br />
            <span style={{
            color: GOLD
          }}>and asked for theirs to match</span>.
          </h2>

          <div className="flex items-center gap-3">
            <div className="flex gap-1">
              {[0, 1, 2, 3, 4].map(i => <span key={i} aria-hidden data-icon-container="lucide-do-not-replace" className="inline-flex">
                  <Star size={16} color={GOLD} fill={GOLD} strokeWidth={0} />
                </span>)}
            </div>
            <span style={{
            fontFamily: FONT_HEAD,
            fontSize: "14px",
            fontWeight: 700,
            color: "#ffffff"
          }}>
              5.0
            </span>
            <span style={{
            fontFamily: FONT_BODY,
            fontSize: "14px",
            color: "rgba(255,255,255,0.6)"
          }}>
              · 200+ Google reviews
            </span>
          </div>
        </div>

        {/* Cards grid */}
        <div className="grid md:grid-cols-3 gap-5">
          {REVIEWS.map(r => <article key={r.name} className="relative rounded-2xl overflow-hidden transition-all hover:translate-y-[-3px]" style={{
          backgroundColor: `${NAVY_LIGHT}66`,
          border: r.featured ? `2px solid ${GOLD}66` : `1px solid rgba(255,255,255,0.08)`,
          boxShadow: r.featured ? `0 30px 80px rgba(0,0,0,0.5), 0 0 0 1px ${GOLD}33` : "0 10px 30px rgba(0,0,0,0.2)"
        }}>
              {/* Photo at top */}
              <div className="relative overflow-hidden" style={{
            aspectRatio: "4 / 3",
            backgroundColor: "#0e1a36"
          }}>
                <img src={r.photo} alt={r.photoAlt} loading="lazy" draggable={false} className="w-full h-full object-cover" />

                {/* Gradient */}
                <div aria-hidden className="absolute inset-0 pointer-events-none" style={{
              background: "linear-gradient(180deg, transparent 40%, rgba(8,20,56,0.85) 100%)"
            }} />

                {/* Camera badge — top left */}
                <div className="absolute top-3 left-3 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full" style={{
              backgroundColor: "rgba(8,20,56,0.85)",
              backdropFilter: "blur(6px)",
              border: `1px solid ${GOLD}33`
            }}>
                  <span aria-hidden data-icon-container="lucide-do-not-replace" className="inline-flex">
                    <Camera size={10} color={GOLD} strokeWidth={2.5} />
                  </span>
                  <span style={{
                fontFamily: FONT_HEAD,
                fontSize: "10px",
                fontWeight: 800,
                letterSpacing: "0.12em",
                textTransform: "uppercase",
                color: GOLD
              }}>
                    {r.pill}
                  </span>
                </div>

                {/* Suburb tag — bottom left */}
                <div className="absolute bottom-3 left-3 flex items-center gap-1.5">
                  <span aria-hidden data-icon-container="lucide-do-not-replace" className="inline-flex">
                    <MapPin size={12} color="#ffffff" strokeWidth={2.5} />
                  </span>
                  <span style={{
                fontFamily: FONT_HEAD,
                fontSize: "13px",
                fontWeight: 800,
                color: "#ffffff",
                letterSpacing: "-0.01em"
              }}>
                    {r.suburb}, Sydney
                  </span>
                </div>

                {/* Featured badge */}
                {r.featured && <div className="absolute top-3 right-3" style={{
              padding: "4px 10px",
              borderRadius: "999px",
              background: `linear-gradient(135deg, ${GOLD} 0%, ${GOLD_DARK} 100%)`,
              color: NAVY,
              fontFamily: FONT_HEAD,
              fontSize: "9.5px",
              fontWeight: 900,
              letterSpacing: "0.16em",
              textTransform: "uppercase",
              boxShadow: `0 4px 12px ${GOLD}66`
            }}>
                    ★ Featured
                  </div>}
              </div>

              {/* Content */}
              <div className="p-6 md:p-7 relative">
                {/* Stars */}
                <div className="flex items-center justify-between mb-4">
                  <div className="flex gap-0.5">
                    {Array.from({
                  length: r.rating
                }).map((_, i) => <span key={i} aria-hidden data-icon-container="lucide-do-not-replace" className="inline-flex">
                        <Star size={13} color={GOLD} fill={GOLD} strokeWidth={0} />
                      </span>)}
                  </div>
                  <span aria-hidden data-icon-container="lucide-do-not-replace" className="inline-flex">
                    <Quote size={18} color={GOLD} strokeWidth={2.25} />
                  </span>
                </div>

                {/* Quote */}
                <p style={{
              fontFamily: FONT_BODY,
              fontSize: "14.5px",
              lineHeight: 1.65,
              color: "rgba(255,255,255,0.9)",
              marginBottom: "20px",
              fontWeight: 500
            }} dangerouslySetInnerHTML={{
              __html: r.quote
            }} />

                {/* Attribution */}
                <div className="pt-4 border-t" style={{
              borderColor: "rgba(255,255,255,0.1)"
            }}>
                  <div style={{
                fontFamily: FONT_HEAD,
                fontWeight: 800,
                fontSize: "14px",
                color: "#ffffff",
                letterSpacing: "-0.01em",
                marginBottom: "4px"
              }} dangerouslySetInnerHTML={{
                __html: r.name
              }} />
                  <div style={{
                fontFamily: FONT_HEAD,
                fontSize: "11px",
                fontWeight: 700,
                color: GOLD,
                letterSpacing: "0.04em"
              }} dangerouslySetInnerHTML={{
                __html: r.install
              }} />
                </div>
              </div>
            </article>)}
        </div>

        {/* Bottom CTA */}
        <div className="mt-12 text-center">
          <p style={{
          fontFamily: FONT_BODY,
          fontSize: "15px",
          color: "rgba(255,255,255,0.7)",
          marginBottom: "20px",
          maxWidth: "560px",
          marginLeft: "auto",
          marginRight: "auto"
        }}>
            <span style={{
            color: GOLD,
            fontFamily: FONT_HEAD,
            fontWeight: 700
          }}>
              See one you like?
            </span>{" "}
            Tell us the photo number — we'll quote yours to match.
          </p>
          <a href="tel:0485000933" className="inline-flex items-center gap-2.5 px-7 py-4 rounded-full transition-all hover:scale-[1.02]" style={{
          backgroundColor: GOLD,
          color: NAVY,
          fontFamily: FONT_HEAD,
          fontWeight: 700,
          fontSize: "15px",
          boxShadow: `0 12px 30px ${GOLD}44`
        }}>
            <span aria-hidden data-icon-container="lucide-do-not-replace" className="inline-flex">
              <Phone size={17} strokeWidth={2.5} />
            </span>
            Quote one to match
            <span aria-hidden data-icon-container="lucide-do-not-replace" className="inline-flex">
              <ArrowRight size={15} strokeWidth={2.5} />
            </span>
          </a>
        </div>
      </div>

      {/* Bottom gold scanline */}
      <div aria-hidden className="absolute bottom-0 left-0 right-0 h-px" style={{
      background: `linear-gradient(90deg, transparent, ${GOLD}66 50%, transparent)`
    }} />
    </section>;
}